import apiClient from '../../../apis/portaliref';
import { portaleApi } from '../../../helpers/portaleModuleHelper';

const api = portaleApi('schedahotel', apiClient, {
    per_page: 'perPage',
    page: 'page',
    slug: 'q',
    orderby: 'orderKey',
    orderdir: 'orderDirection',
    stato_pubblicazione: 'stato_pubblicazione',
    portale: 'portale',
    anagrafica: 'ao_hotel_id'
});

api.fetch = (id) => {
    return apiClient({
        // url: `schedahotel/${id}?portal_id=${portaleId}&include=info`
        url: `schedahotel/${id}`,
    });
};

api.editScheda = (id, data) => {
    return apiClient({
        url: `schedahotel/${id}`,
        method: 'patch',
        data,
    });
};

api.filtriScheda = (filter) => {
    return apiClient({
        url: `schedahotel/filtri`,
        method: 'get',
        filter,
    });
};

api.deleteScheda = (id) => {
    return apiClient({
        url: `schedahotel/${id}`,
        method: 'delete',
    });
};

api.riassegnaAnagrafica = (id, data) => {
    return apiClient({
        url: `schedahotel/${id}/anagrafica`,
        method: 'put',
        data,
    });
};

export default api;
